module.exports = __webpack_public_path__ + "static/Gordes-3f12d7b8abb36e948ec143c5ecd97479.jpg";